import React from 'react';
import {Link} from 'react-router-dom';
import MenuItem from "@mui/material/MenuItem";
import {QD_URL} from "../../constants/systemConstants";


export default function ArgoLeftNavLinkHook(props) {

    const linkTo = props.linkTo === undefined ? "" : QD_URL + props.linkTo;
    const title = props.title ?? "undefined";

    const uniqueIdentifier = "ArgoLeftNavLinkHook-" + title.toLowerCase().replaceAll(" ", "-");

    const onClick = props.onClick ?? function () {};

    const handleOnClick = (event) => {
        onClick(event)
    };

    return (
        linkTo === "" ?
            <MenuItem
                tabIndex={0}
                style={{color: "black"}}
                onClick={handleOnClick}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault()
                        handleOnClick()
                    }
                }}
            >{title}</MenuItem>
            :
            <Link id={uniqueIdentifier}
                  style={{color: "black", textDecoration: 'none'}}
                  to={linkTo}
                  onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault()
                          handleOnClick()
                      }
                  }}
            >
                <MenuItem onClick={handleOnClick}>{title}</MenuItem>
            </Link>
    );
}


